import { getStationaryBookingProgress } from '@components/BookingFlow/Common/bookingFlowProgress';
import { BookingStepUnavailablePage } from '@components/BookingFlow/Common/BookingStepUnavailablePage';
import { IncomingTireSeasonChoice } from '@components/BookingFlow/Common/IncomingTireSeasonChoice';
import { StationaryBookingScreen } from '@components/BookingFlow/Stationary/StationaryBookingScreen';
import { t } from '@lingui/core/macro';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import {
  useStationaryBookingActions,
  useStationaryBookingCar,
  useStationaryIncomingTireSeason
} from '../../../../stores/StationaryBookingStore';

/** Which wheel set the garage stores, when the booking signs the car up for the tire hotel. Never preselected. */
export const StationaryBookingTireSeason = () => {
  const navigate = useNavigate();
  const selectedCar = useStationaryBookingCar();
  const incomingTireSeason = useStationaryIncomingTireSeason();
  const { setIncomingTireSeason } = useStationaryBookingActions();

  if (!selectedCar) {
    return <BookingStepUnavailablePage missing='car' />;
  }

  return (
    <StationaryBookingScreen
      progress={getStationaryBookingProgress('services')}
      onNextClicked={() => {
        navigate(customerRoutes.newStationaryBookingTimeWindow.getPath());
      }}
      disableNextButton={!incomingTireSeason}
      validationVariant='tireHotelSeasonRequired'
      title={t`Which tires should we store?`}
      description={t`We take the tires you choose to our tire hotel.`}
    >
      <IncomingTireSeasonChoice
        cars={[{ car: selectedCar, selectedSeason: incomingTireSeason }]}
        onSelect={(_car, season) => setIncomingTireSeason(season)}
      />
    </StationaryBookingScreen>
  );
};
